<template>
  <div v-if="shouldShowShareLinkPanel" class="well well--library">
    <div class="share-link-panel">
      <h4 class="share-link-header text-left">Send to caregivers or colleagues</h4>
      <button
        v-show="!shared"
        @click="shareStrategy()"
        :disabled="sharing"
        class="btn btn-primary btn-block">
        <span v-if="!sharing"><i class="fa fa-link"/>Create a View-only Link</span>
        <span v-if="sharing"><i class="fa fa-circle-o-notch fa-spin fa-fw"/> Loading...</span>
      </button>
      <div v-show="shared">
        <p class="share-link-warning"><i class="fa fa-eye"/> Anyone with the link can view<br>
          <button
            class="make-private btn-link"
            v-if="editorVisibility"
            @click="unshareStrategy()"
            type="button"><small>Make private</small></button></p>
        <p class="input-group">
          <span class="input-group-addon"><i class="fa fa-link"/></span>
          <input
            @focus="$event.target.select()"
            type="text"
            class="form-control shared-link-display"
            readonly
            :value="shareLink">
        </p>
        <CopyButton
          btn-class="btn btn-default btn-block"
          :copy-text="shareLink"
          success-text="Link copied!"
          error-text="Error copying text! Use Ctrl + C instead."
          @copied="handleLinkCopied"
        >
          <i class="fa fa-link" aria-hidden="true"/> Copy Link
        </CopyButton>
      </div>
    </div>
    <LimitActionModal :show.sync="showBlocker" :action-permissions="actionPermissions" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CONTENT_TYPES, ACTION_TYPES, actionPermissions } from '@/util/access_visibility'

import { shareStrategy, unshareStrategy } from '@/api/strategies'

import LimitActionModal from '@/components/LimitActionModal'
import CopyButton from '@/components/CopyButton'

export default {
  name: 'ShareStrategyPanel',
  components: {
    LimitActionModal,
    CopyButton
  },
  props: {
    uuid: {
      required: true,
      type: String
    },
    shareState: {
      required: true,
      type: Boolean
    },
    shareLinkState: {
      required: false,
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      sharing: false,
      shared: this.shareState,
      shareLink: this.shareLinkState,
      showBlocker: false
    }
  },
  computed: {
    ...mapGetters('visibility', ['editorVisibility', 'shareVisibility']),
    ...mapGetters('user', ['authInfo']),
    ...mapGetters('library', ['isUserRoleResolvedForCurrentFolder', 'isCurrentUserContributorForCurrentFolder']),
    actionPermissions() {
      return actionPermissions(ACTION_TYPES.SHARE, CONTENT_TYPES.SAVED_STRATEGY, {}, this.authInfo)
    },
    shouldShowShareLinkPanel() {
      return (
        this.shareVisibility &&
        this.isUserRoleResolvedForCurrentFolder &&
        !this.isCurrentUserContributorForCurrentFolder
      )
    }
  },
  methods: {
    shareStrategy() {
      this.sharing = true
      shareStrategy(this.uuid)
        .then(data => {
          this.sharing = false
          this.shared = true
          this.shareLink = data.share_link
          this.$sendEvent('Library Strategy Shared')
        })
        .catch(err => {
          this.sharing = false
          console.error('error sharing strategy', err)
        })
      this.$sendEvent('Clicked Create Share Link')
    },
    unshareStrategy() {
      unshareStrategy(this.uuid).then(() => {
        this.shared = false
      })
      .catch(err => {
        console.error('error unsharing strategy', err)
      })
    },
    handleLinkCopied() {
      this.$sendEvent('Copied Share Link', {
        share_content_type: CONTENT_TYPES.SAVED_STRATEGY
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';
.share-link-warning {
  padding: 10px 0;
  background-color: @brand-primary;
  border: 1px solid @gray-lighter;
  border-radius: 4px;
  color: white;
}
.share-link-panel {
  text-align: center;
}
.shared-link-display {
  overflow: hidden;
  cursor: text;
}
.make-private {
  color: #d6f0f7;
}
.well--library h4 {
  margin-top: 0;
}
</style>
